import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import fp from 'lodash/fp';
import { Button, Spinner, Alert } from '@deerplusofficial/pos-components';
import { mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import SideInfoContainer from './SideInfoContainer';
import { withCreateOrderQrcode, withCancelOrder } from '../../model/Mutations';
import { withQueryPayment, withQueryProducts } from '../../model/Queries';
import actions from '../../actions';

const QrcodeContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  margin-top: 20px;
`;

const Qrcode = styled.img`
  vertical-align: middle;
  margin: -20px auto 0;
`;

class QrcodesTab extends PureComponent {
  static propTypes = {
    meta: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      })
    ),
  };

  static defaultProps = {
    meta: [],
  };

  state = {
    isFetchingQrcode: false,
  };

  async componentWillUnmount() {
    const {
      onOrderCancel,
      payment: { id: paymentId },
      receipt: { orderId },
    } = this.props;

    if (!paymentId) return;

    await onOrderCancel({
      orderId,
      note: 'Cancel the order created by dynamic QR code.',
    });
  }

  onQrcodeCreate = () => {
    const { onOrderQrcodeCreate, meta } = this.props;
    // TODO: 未來需要從 meta 取得各個不同支付方式的 id 來帶入
    const methodId = _.get(...meta, 'id');

    this.setState({ isFetchingQrcode: true }, async () => {
      await onOrderQrcodeCreate(methodId);
      this.setState({ isFetchingQrcode: false });
    });
  };

  onPaymentCheck = async () => {
    const {
      onPaymentCheck,
      editOrderStep,
      fetchProducts,
      resetPayment,
    } = this.props;

    const { status } = await onPaymentCheck();

    if (status !== 100) {
      Alert.fire({ type: 'warning', titleText: '尚未完成付款' });
      return;
    }

    resetPayment();
    editOrderStep('done');
    fetchProducts();
  };

  renderQrcode = () => {
    const {
      payment: { qrcode, id, checking },
    } = this.props;

    if (_.isUndefined(qrcode))
      return (
        <Button primary onClick={this.onQrcodeCreate}>
          產生動態二元碼
        </Button>
      );

    return (
      <React.Fragment>
        <Qrcode
          width={320}
          height={320}
          src={`data:image/png;base64,${qrcode}`}
        />
        <Button
          primary
          disabled={!id}
          loading={checking}
          onClick={this.onPaymentCheck}
        >
          確認已付款
        </Button>
      </React.Fragment>
    );
  };

  render() {
    const { isFetchingQrcode } = this.state;

    return (
      <SideInfoContainer>
        <QrcodeContainer>
          {isFetchingQrcode ? <Spinner dark /> : this.renderQrcode()}
        </QrcodeContainer>
      </SideInfoContainer>
    );
  }
}

const { edit: editOrderStep } = actions.orderStep;
const { reset: resetPayment } = actions.payment;

export default fp.compose(
  withCreateOrderQrcode(),
  withCancelOrder(),
  withQueryPayment(),
  withQueryProducts(),
  connect(
    mapState(['orderStep', 'receipt', 'payment']),
    { editOrderStep, resetPayment }
  )
)(QrcodesTab);



// WEBPACK FOOTER //
// ./src/components/CheckoutPanel/QrcodesTab.js